import $ from 'jquery';

export default {
	init() {
		console.log('Nylon NetReveal Homepage Template');

		// progress scroll
		var addClassOnScroll = function ($progressBarEl) {
			// how far window scroll is past top
			var windowTop = $(window).scrollTop();

			$('.ai-block[id]').each(function (index, elem) {
				// how far element is from top
				var offsetTop = $(elem).offset().top,
						outerHeight = $(this).outerHeight(true),
						$darkBgChild = null;

				// if distance to top of window is greater than the element's distance from top - 200px (offset)
				// in other words, if element is 200px from top of window
				if (windowTop > offsetTop - 200 && windowTop < offsetTop + outerHeight) {
					var elemId = $(elem).attr('id');
					$('.sticky-section a.active').removeClass('active');
					$('.sticky-section a[href="#' + elemId + '"]').addClass('active');

					// if element has a child with the .dark-bg class
					if ($(elem).find('.dark-bg').length) {
						var $darkBgChild = $(elem).find('.dark-bg'),
								darkOffsetTop = $darkBgChild.offset().top,
								darkOuterHeight = $darkBgChild.outerHeight(true);

						// if dark el is 300px from top AND you're still in the dark el (minus 300px)
						if (windowTop > darkOffsetTop - 300 && windowTop < darkOffsetTop + darkOuterHeight - 300) {
							$('.netreveal-sticky-nav').addClass('color-light');
						// if scrolled past 300px before the dark element
						} else if (windowTop > darkOffsetTop + darkOuterHeight - 300) {
							$('.netreveal-sticky-nav').removeClass('color-light');
						} else {
							$('.netreveal-sticky-nav').removeClass('color-light');
						}
					}
				}
			});
		};

		// only call if the sticky nav exists && it's visible (so it won't run on mobile)
		if ($('.netreveal-sticky-nav').length && $('.netreveal-sticky-nav').is(':visible')) {
			let $progressBarEl = $('.netreveal-sticky-nav');

			// init scroll watching function on page load
			addClassOnScroll($progressBarEl);

			// on window scroll
			$(window).on('scroll', function () {
				addClassOnScroll();
			});

			// if it's the Netreveal style hero, change the sticky nav to blue
			// to correspond to the bg color swipe animation
			if ($('#main .ai-block-netreveal-home-hero:not(.no-swipe)').length) {
				setTimeout(function() {
					$progressBarEl.removeClass('color-light');
				}, 2200);
			}
		}
	},
	finalize() {},
};
